import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-modal-bom-select',
  templateUrl: './modal-bom-select.component.html',
  styleUrls: ['./modal-bom-select.component.css'],
  standalone: false
})
export class ModalBomSelectComponent extends TypeaheadBase implements OnInit {

  @Input() vm: any;
  @Output() selectBOMModalEmit = new EventEmitter<string>();
  @Output() updateBOMEmit = new EventEmitter<string>();
  @Output() filterBOMEmit = new EventEmitter<string>();
  @Output() bomSelectedEmit = new EventEmitter<string>();

  constructor() {
    super();
  }

  bomTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.bomName, 10);

  ngOnInit() {
  }

  selectBOMModal(id) {
    this.selectBOMModalEmit.emit(id);
  }

  updateBOM() {
    this.updateBOMEmit.emit();
  }

  filterBOM(){
    this.filterBOMEmit.emit();
  }

  bomSelected(){
    this.bomSelectedEmit.emit();
  }

  onBomBlur(typeahead: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.bomSelected();
  }
}
